<template>
  <div class="container">
    <div class="page">
      <div class="header">
        <div class="left">
          订单需要补差价，请尽快付款！订单号：{{ detail.order_no }}
        </div>
        <div class="right">
          应付金额 <span class="money">￥{{ detail.makeup }}</span>
        </div>
      </div>
      <div class="content">
        <div class="img-wrap">
          <img
            src="../../assets/images/icon_weixin@2x.png"
            alt=""
            class="icon"
          />
          <span>微信支付</span>
        </div>
        <div class="tip">
          距离二维码过期还剩
          <span class="second">{{ second }}</span>
          秒，过期后请刷新页面重新获取二维码
        </div>
        <div class="code-wrap">
          <div class="left">
            <div class="qrcode">
              <canvas
                width="270"
                height="270"
                ref="c"
                id="qrccode-canvas"
                style="width: 100%; height: 100%"
              ></canvas>
              <p class="hint">
                请使用微信扫一扫<br />
                扫描二维码支付
              </p>
            </div>
          </div>
          <div class="right">
            <img src="../../assets/images/pay-help1.png" alt="" class="help" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let QRCode = require("qrcode");
import { Profile, OrderDetail, MakeupOrder, CheckPayStatus } from "@/api/index.js";
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "CashDesk",
  components: {},
  data() {
    return {
      uuid: "",
      pay_type: "",
      detail: {},
      second: 300,
      interval_id1: null,
      interval_id2: null,
      log_id: 0,
    };
  },
  computed: {
    ...mapState(["setting"]),
  },
  methods: {
    generate(url) {
      QRCode.toCanvas(this.$refs.c, url, { width: 270 }, (error) => {
        if (error) {
          console.log(error);
        }
      });
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    onOrderPay() {
      const { uuid, pay_type } = this;
      const param = {};
      param.uuid = uuid;
      param.pay_type = pay_type;
      MakeupOrder(param)
        .then((response) => {
            this.generate(response.data.url);
            this.interval_id1 = setInterval(() => {
              this.second--;
              if (this.second === 0) {
                clearInterval(this.interval_id1);
                this.second = 300;
                location.reload();
              }
            }, 1000);
            this.interval_id2 = setInterval(() => {
              CheckPayStatus({ pay_id: response.data.pay_id }).then((res) => {
                if (res.data.status === 1) {
                  clearInterval(this.interval_id2);
                  this.$router.replace({
                    name: "PayResult",
                    query: { uuid: this.uuid },
                  });
                }
              });
            }, 3000);

        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        });
    },
  },
  mounted() {
    this.uuid = this.$route.query.uuid;
    this.pay_type = this.$route.query.pay_type;
    if (this.$route.query.uuid) {
      OrderDetail({
        uuid: this.$route.query.uuid,
      }).then((response) => {
        this.detail = response.data;
      });
    }
    this.onOrderPay();
    axios.all([this.getProfile()]).then(axios.spread(() => {}));
  },
};
</script>

<style scoped lang="scss">
.container {
  background: #f6f7fa;
  padding: 30px 200px 100px 200px;
  .page {
    width: 1500px;
    margin: 0 auto;
    padding: 0 70px;
    background: white;
    border-radius: 10px 10px 10px 10px;
    .header {
      height: 92px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #dbdbdb;
      color: #333;
      .right {
        .money {
          font-size: 24px;
          color: #fa3d5a;
        }
      }
    }

    .content {
      .img-wrap {
        display: flex;
        align-items: center;
        font-size: 26px;
        margin: 25px 0;
        .icon {
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
      }
      .tip {
        color: #737373;
        font-size: 14px;
        .second {
          color: #fa3d5a;
        }
      }

      .code-wrap {
        padding: 66px 0 200px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .left {
          .qrcode {
            width: 270px;
            height: 270px;
          }
          .hint {
            background: #fa3d5a;
            padding: 5px 10px;
            color: white;
            text-align: center;
          }
        }

        .right {
          .help {
            margin-left: 100px;
            width: 250px;
            height: 320px;
          }
        }
      }
      .upload-result {
        display: flex;
        justify-content: center;
        align-items:center;
        flex-wrap: wrap;
        column-gap: 75px;
        margin-top: 49px;
        .upload-btn {
          width: 301px;
          height: 301px;
          background: #f5f8f7;
          border: 1px dashed #cccccc;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .btn-icon {
            width: 82px;
            height: 63px;
          }
          .btn-text {
            margin-top: 28px;
            margin-bottom: 19px;
            font-weight: bold;
            color: #5b5f66;
            font-size: 16px;
          }
          .btn-desc {
            color: #999999;
            font-size: 13px;
          }
        }
        .upload-res {
          position: relative;
          width: 300px;
          height: 300px;
          overflow: visible;
          .res-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .remove-btn {
            position: absolute;
            top: -10px;
            right: -10px;
            width: 28px;
            height: 28px;
            z-index: 10;
          }
        }
        .upload-tips {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .tips-title {
            color: #999999;
            font-weight: bold;
            font-size: 16px;
          }
          .tips-content {
            margin-top: 25px;
            color: #808080;
            font-size: 13px;
            line-height: 28px;
            .line{
              width:100%;
              border-bottom:1px dashed #cccccc;
              margin:26px 0;
            }
            .pay-title{
              color:#333333;
              font-size:16px;
              margin-bottom:19px;
            }
            .pay-item{
              display: flex;
              align-items:center;
              font-size:13px;
              .label{
                color:#666666;
              }
              .value{
                color:#1a1a1a;
                span{
                  border-radius:11px;
                  border:1px solid #fa3d5a;
                  cursor:pointer;
                  color:#fa3d5a;
                  padding:3px 10px;
                  margin-left:10px;
                }
              }
            }
          }
        }
        .btn-box {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 60px;
          margin-bottom: 73px;
          .btn {
            border-radius: 30px;
            width: 260px;
            height: 60px;
            background: #fa3d5a;
            color: #ffffff;
            line-height: 60px;
            cursor: pointer;
            text-align: center;
            font-size: 14px;
          }
        }
        .back-btn {
          width: 100%;
          margin-bottom: 104px;
          color: #575859;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep .ivu-upload-drag {
  overflow: visible;
}
</style>
